import React from 'react';
import rxLogo from './rx_logo_dark.svg';
import './NavigationBar.css';

const NavigationBar = ({
                           loggedIn,
                           onLogout,
                           goToHistorical,
                           goToFirstStep,
                           goToSettings
                       }) => {
    const handleLogoClick = () => {
        if (loggedIn) {
            goToFirstStep();
        }
    };

    return (
        <nav className="navigation-bar">
            <div className="nav-container">
                {/* Logo Section */}
                <div className="nav-logo" onClick={handleLogoClick}>
                    <img src={rxLogo} alt="" className="logo-icon" />
                </div>

                {/* Navigation Items */}
                {loggedIn && (
                    <div className="nav-items">
                        <button
                            className="nav-item"
                            onClick={goToHistorical}
                        >
                            History
                        </button>
                        <button
                            className='nav-item'
                            onClick={goToFirstStep}
                        >
                            New Evaluation
                        </button>
                        <button
                            className="nav-item"
                            onClick={goToSettings}
                        >
                            Settings
                        </button>
                        <div className="nav-separator" />
                        <button
                            className="nav-item logout"
                            onClick={onLogout}
                        >
                            Logout
                        </button>
                    </div>
                )}

                {/* Contact Info for Non-logged in Users */}
                {!loggedIn && (
                    <div className="nav-contact">
                        <a href="tel:02 8283 4099" className="contact-link">
                            <svg className="phone-icon" viewBox="0 0 24 24">
                                <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"/>
                            </svg>
                            02 8283 4099
                        </a>
                    </div>
                )}
            </div>
        </nav>
    );
};

export default NavigationBar;